import { GenericError, IErrorDetails } from '@cian/peperrors';

export class ResponseError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({ ...configuration, type: 'ResponseError' });

    Object.setPrototypeOf(this, ResponseError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResponseError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
